import { createDecorator } from 'vue-class-component';
import { ComputedOptions } from 'vue/types/umd';

/**
 * The decorator disables caching of computed properties
 * Copy-pasted from https://github.com/vuejs/vue-class-component
 */
export const NoCache = createDecorator((options, key) => {
    // component options should be passed to the callback
    // and update for the options object affect the component
    (options.computed![key] as ComputedOptions<any>).cache = false;
});
